module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', {
    staticClass: "legacy-sunset-banner",
    attrs: {
      "aria-label": "Legacy interface retirement announcement"
    }
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "legacy-sunset-banner__cta",
    attrs: {
      "href": _vm.v3Url
    }
  }, [_vm._v("\n    Try V3 "), _c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("→")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "legacy-sunset-banner__message"
  }, [_c('strong', [_vm._v("This legacy interface will retire in December 2026.")]), _vm._v(" "), _c('span', [_vm._v("Start using V3 today to get ready for the switch.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f54822ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/core/LegacySunsetBanner.vue
// module id = 2322
// module chunks = 0